<template>
  <v-layout row :class="[data.dateChanged ? 'newDate' : 'sameDate']">
    <v-flex xs4 class="col">
      <span v-if="data.dateChanged">{{data.resourceUsageDate}}</span>
    </v-flex>
    <v-flex v-if="$t(`resources.identifiers.${data.resourceIdentifier}`).includes('resources.identifiers')" xs5 class="col">
      {{$t(`${data.resourceIdentifier}`)}}
    </v-flex>
    <v-flex v-else xs5 class="col">
      {{$t(`resources.identifiers.${data.resourceIdentifier}`)}}
    </v-flex>
    <v-flex xs1 class="body-2 col text-xs-right">
      {{data.resourceCount}}
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'resource-row',
  props: ['data']
}
</script>

<style scoped>
.newDate {
  border-top: 1px solid black;
}
.sameDate {
  border-top: 1px solid lightGray;
}
.col {
  padding: 6px 4px 6px 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/resources/ResourceRow.vue